/* Local Culture — Mega Nav (Magic Spoon inspired) */
(function(){
  /* Inject nav styles */
  var style = document.createElement('style');
  style.textContent = '\
.mn-announce{position:fixed;top:0;left:0;right:0;z-index:1001;min-height:36px;background:var(--beet,#a03050);color:#fff;text-align:center;font-family:var(--sans,system-ui);font-size:12px;font-weight:600;letter-spacing:.04em;padding:8px 44px;padding-top:calc(8px + env(safe-area-inset-top,0px));line-height:1.3;display:flex;align-items:center;justify-content:center;gap:6px;text-wrap:balance}\
.mn-announce svg{width:14px;height:14px;flex-shrink:0}\
.mn-announce-close{background:none;border:none;color:rgba(255,255,255,0.7);cursor:pointer;padding:4px;margin-left:8px;line-height:1;display:flex;transition:color .2s}\
.mn-announce-close:hover{color:#fff}\
.mn-announce-close svg{width:12px;height:12px}\
body.has-announce{padding-top:var(--mn-announce-h,36px)!important}\
.mn{position:fixed;top:0;left:0;right:0;z-index:1000;background:var(--bg,#faf5ef);transition:all .4s cubic-bezier(.23,1,.32,1);border-bottom:2px solid transparent}\
body.has-announce .mn{top:var(--mn-announce-h,36px)!important}\
.mn.scrolled{border-bottom-color:var(--line,rgba(0,0,0,.08));box-shadow:0 2px 12px rgba(0,0,0,.04)}\
.mn-bar{max-width:1400px;margin:0 auto;padding:10px clamp(20px,4vw,60px);display:flex;align-items:center;gap:20px;justify-content:space-between;position:relative;overflow:visible}\
.mn-logo{height:clamp(40px,4.5vw,52px);flex-shrink:0;transition:opacity .3s}\
.mn-logo:hover{opacity:.85}\
.mn-links{display:flex;gap:clamp(24px,2.5vw,40px);align-items:center;list-style:none;margin:0;padding:0;position:absolute;left:50%;transform:translateX(-50%)}\
.mn-links a{font-family:"Lilita One",var(--serif,Georgia,serif);font-size:clamp(14px,1.2vw,16px);font-weight:400;color:var(--beet,#a03050);letter-spacing:.03em;text-transform:uppercase;text-decoration:none;position:relative;transition:color .25s;padding:6px 0;display:inline-flex;align-items:center;gap:4px}\
.mn-links a:hover{color:var(--beet,#a03050)}\
.mn-links a.active{color:var(--beet,#a03050)}\
.mn-links a.active::after{content:"";position:absolute;bottom:0;left:0;right:0;height:2.5px;background:var(--beet,#a03050);border-radius:2px}\
.mn-links .mn-badge{font-family:var(--sans,system-ui);font-size:9px;font-weight:700;letter-spacing:.06em;background:var(--turmeric,#c99a30);color:#fff;padding:2px 7px;border-radius:100px;margin-left:2px;text-transform:uppercase;line-height:1.3}\
.mn-cta{font-family:"Lilita One",var(--serif);font-size:14px;padding:11px 28px;border-radius:100px;background:var(--beet,#a03050);color:#fff;text-decoration:none;letter-spacing:.04em;text-transform:uppercase;border:1.5px solid oklch(0.22 0.06 10);transition:all .25s;flex-shrink:0;display:inline-flex;align-items:center;gap:8px}\
.mn-cta:hover{opacity:.9;transform:translateY(-1px)}\
.mn-cart{position:relative;display:inline-flex;align-items:center;justify-content:center;width:44px;height:44px;text-decoration:none;color:var(--text,#3a2a1a);transition:opacity .25s}\
.mn-cart:hover{opacity:.7}\
.mn-cart svg{width:22px;height:22px}\
.mn-cart-count{position:absolute;top:4px;right:2px;min-width:18px;height:18px;border-radius:100px;background:var(--beet,#a03050);color:#fff;font-family:var(--sans,system-ui);font-size:10px;font-weight:700;display:flex;align-items:center;justify-content:center;padding:0 4px;line-height:1;opacity:0;transform:scale(0);transition:all .25s cubic-bezier(.23,1,.32,1)}\
.mn-cart-count.has-items{opacity:1;transform:scale(1)}\
.mn-right{display:flex;align-items:center;gap:4px;margin-left:auto}\
.mn-burger{width:44px;height:44px;display:none;flex-direction:column;justify-content:center;align-items:center;gap:6px;cursor:pointer;z-index:1002;background:none;border:none;padding:0}\
.mn-burger span{display:block;width:24px;height:2px;background:var(--text,#3a2a1a);transition:all .35s cubic-bezier(.23,1,.32,1);transform-origin:center;border-radius:2px}\
.mn-burger.open span:nth-child(1){transform:translateY(8px) rotate(45deg)}\
.mn-burger.open span:nth-child(2){opacity:0}\
.mn-burger.open span:nth-child(3){transform:translateY(-8px) rotate(-45deg)}\
.mn-mobile{position:fixed;inset:0;z-index:1001;background:var(--bg,#faf5ef);overflow-y:auto;-webkit-overflow-scrolling:touch;opacity:0;pointer-events:none;transition:opacity .35s cubic-bezier(.23,1,.32,1)}\
.mn-mobile.open{opacity:1;pointer-events:auto}\
.mn-mobile-top{display:flex;align-items:center;justify-content:space-between;padding:14px clamp(20px,4vw,40px);border-bottom:2px solid var(--line,rgba(0,0,0,.08))}\
.mn-mobile-logo{height:48px}\
.mn-mobile-links{list-style:none;padding:0;margin:0}\
.mn-mobile-links li{border-bottom:1.5px solid var(--line,rgba(0,0,0,.08))}\
.mn-mobile-links a{display:flex;align-items:center;gap:16px;padding:14px clamp(20px,4vw,40px);text-decoration:none;color:var(--text,#3a2a1a);transition:background .2s}\
.mn-mobile-links a:hover{background:rgba(0,0,0,.02)}\
.mn-mobile-links .mn-mob-label{font-family:"Lilita One",var(--serif);font-size:clamp(16px,4.5vw,20px);font-weight:400;letter-spacing:.03em;text-transform:uppercase;color:var(--beet,#a03050)}\
.mn-mobile-cta-wrap{padding:24px clamp(20px,4vw,40px);text-align:center;border-bottom:1.5px solid var(--line,rgba(0,0,0,.08))}\
.mn-mobile-cta{display:inline-flex;align-items:center;justify-content:center;gap:8px;padding:16px 40px;border-radius:100px;background:var(--beet,#a03050);color:#fff;font-family:"Lilita One",var(--serif);font-size:16px;letter-spacing:.04em;text-transform:uppercase;text-decoration:none;border:1.5px solid oklch(0.22 0.06 10);width:100%;max-width:400px;transition:all .25s}\
.mn-mobile-cta:hover{opacity:.9}\
.mn-mobile-brand{display:grid;grid-template-columns:1fr 1fr;gap:0;padding:0}\
.mn-mobile-brand a{font-family:"Lilita One",var(--serif);font-size:clamp(14px,3.5vw,16px);font-weight:400;letter-spacing:.03em;text-transform:uppercase;color:var(--beet,#a03050);text-decoration:none;text-align:center;padding:18px 12px;transition:background .2s;border-bottom:1px solid var(--line,rgba(0,0,0,.08))}\
.mn-mobile-brand a:nth-child(odd){border-right:1px solid var(--line,rgba(0,0,0,.08))}\
.mn-mobile-brand a:hover{background:rgba(0,0,0,.02)}\
.mn-mobile-quote{margin:20px clamp(20px,4vw,40px) 32px;padding:24px;border-radius:16px;background:oklch(0.96 0.04 85);text-align:center}\
.mn-mobile-quote .mn-q-stars{color:var(--turmeric,#c99a30);font-size:20px;letter-spacing:2px;display:block;margin-bottom:10px}\
.mn-mobile-quote .mn-q-text{font-family:var(--serif,Georgia,serif);font-style:italic;font-size:clamp(14px,3.5vw,16px);color:var(--text,#3a2a1a);line-height:1.7;margin-bottom:12px}\
.mn-mobile-quote .mn-q-attr{font-size:12px;font-weight:600;color:var(--accent,#3a7a5a);display:flex;align-items:center;justify-content:center;gap:6px}\
@media(max-width:960px){.mn-links,.mn-cta{display:none!important}.mn-burger{display:flex}}\
@media(min-width:961px){.mn-mobile{display:none!important}}\
body.mn-hero .mn{background:transparent}\
body.mn-hero .mn.scrolled{background:var(--bg,#faf5ef)}\
body.mn-hero .mn:not(.scrolled) .mn-links a{color:#fff}\
body.mn-hero .mn:not(.scrolled) .mn-links a.active{color:#fff}\
body.mn-hero .mn:not(.scrolled) .mn-links a.active::after{background:#fff}\
body.mn-hero .mn:not(.scrolled) .mn-links .mn-badge{background:rgba(255,255,255,0.25);color:#fff}\
body.mn-hero .mn:not(.scrolled) .mn-cta{background:rgba(255,255,255,0.15);border-color:rgba(255,255,255,0.4);color:#fff}\
body.mn-hero .mn:not(.scrolled) .mn-cta:hover{background:rgba(255,255,255,0.25)}\
body.mn-hero .mn:not(.scrolled) .mn-burger span{background:#fff}\
body.mn-hero .mn:not(.scrolled) .mn-cart{color:#fff}\
';
  document.head.appendChild(style);

  /* Determine current page from Shopify template class */
  var body = document.body.className;
  var page = 'home';
  if (body.indexOf('template-product') > -1) page = 'product';
  else if (body.indexOf('template-collection') > -1) page = 'products';
  else if (body.indexOf('template-blog') > -1 || body.indexOf('template-article') > -1) page = 'blog';
  else if (body.indexOf('template-page') > -1) {
    var path = location.pathname;
    if (path.indexOf('about') > -1) page = 'about';
    else if (path.indexOf('bundle') > -1 || path.indexOf('shop') > -1) page = 'shop';
    else if (path.indexOf('locations') > -1) page = 'locations';
    else if (path.indexOf('education') > -1 || path.indexOf('blog') > -1) page = 'blog';
    else if (path.indexOf('contact') > -1) page = 'contact';
    else page = 'page';
  }

  /* Logo — hardcoded fallback so theme pushes never break it */
  var existingLogo = document.querySelector('.header-logo-src');
  var logoSrc = (existingLogo && existingLogo.src) ? existingLogo.src : document.querySelector('[data-logo-fallback]')?.src || '';

  function createLogo(className) {
    var link = document.createElement('a');
    link.href = '/';
    if (logoSrc) {
      var img = document.createElement('img');
      img.src = logoSrc;
      img.alt = 'Local Culture';
      img.className = className;
      img.width = 64;
      img.height = 64;
      link.appendChild(img);
    }
    return link;
  }

  var cartCountEls = [];

  function createCartIcon() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.setAttribute('viewBox','0 0 24 24');
    svg.setAttribute('fill','none');
    svg.setAttribute('stroke','currentColor');
    svg.setAttribute('stroke-width','1.8');
    svg.setAttribute('stroke-linecap','round');
    svg.setAttribute('stroke-linejoin','round');
    var path1 = document.createElementNS('http://www.w3.org/2000/svg','path');
    path1.setAttribute('d','M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z');
    var line1 = document.createElementNS('http://www.w3.org/2000/svg','line');
    line1.setAttribute('x1','3'); line1.setAttribute('y1','6');
    line1.setAttribute('x2','21'); line1.setAttribute('y2','6');
    var path2 = document.createElementNS('http://www.w3.org/2000/svg','path');
    path2.setAttribute('d','M16 10a4 4 0 01-8 0');
    svg.appendChild(path1); svg.appendChild(line1); svg.appendChild(path2);
    return svg;
  }

  function createCart() {
    var a = document.createElement('a');
    a.href = '/cart';
    a.className = 'mn-cart';
    a.setAttribute('aria-label', 'Cart');
    a.addEventListener('click', function(e) {
      if (typeof window.openCartDrawer === 'function') {
        e.preventDefault();
        window.openCartDrawer();
      }
    });
    a.appendChild(createCartIcon());
    var count = document.createElement('span');
    count.className = 'mn-cart-count';
    count.id = 'cart-count';
    count.textContent = '0';
    a.appendChild(count);
    cartCountEls.push(count);
    return a;
  }

  function updateCartCount() {
    fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
      cartCountEls.forEach(function(el){
        el.textContent = cart.item_count;
        el.classList.toggle('has-items', cart.item_count > 0);
      });
    }).catch(function(){});
  }

  /* Build desktop nav */
  var nav = document.createElement('nav');
  nav.className = 'mn';
  nav.id = 'megaNav';

  var bar = document.createElement('div');
  bar.className = 'mn-bar';

  bar.appendChild(createLogo('mn-logo'));

  var ul = document.createElement('ul');
  ul.className = 'mn-links';
  var links = [
    {href:'/collections/all', label:'Products', pg:'products'},
    {href:'/pages/bundle-builder', label:'Bundle Builder', pg:'shop', badge:'Bestseller'},
    {href:'/blogs/education', label:'Education', pg:'blog'},
    {href:'/pages/locations', label:'Locations', pg:'locations'}
  ];
  links.forEach(function(l){
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = l.href;
    a.textContent = l.label;
    if (page === l.pg) a.classList.add('active');
    if (l.badge) {
      var badge = document.createElement('span');
      badge.className = 'mn-badge';
      badge.textContent = l.badge;
      a.appendChild(badge);
    }
    li.appendChild(a);
    ul.appendChild(li);
  });

  var burger = document.createElement('button');
  burger.className = 'mn-burger';
  burger.setAttribute('aria-label','Menu');
  for (var i = 0; i < 3; i++) burger.appendChild(document.createElement('span'));

  var rightGroup = document.createElement('div');
  rightGroup.className = 'mn-right';
  rightGroup.appendChild(createCart());
  rightGroup.appendChild(burger);

  bar.appendChild(ul);
  bar.appendChild(rightGroup);
  nav.appendChild(bar);

  /* Build mobile overlay */
  var mob = document.createElement('div');
  mob.className = 'mn-mobile';
  mob.id = 'mnMobile';

  var mobTop = document.createElement('div');
  mobTop.className = 'mn-mobile-top';
  var mobClose = document.createElement('button');
  mobClose.className = 'mn-burger open';
  mobClose.setAttribute('aria-label','Close menu');
  for (var j = 0; j < 3; j++) mobClose.appendChild(document.createElement('span'));
  mobTop.appendChild(createLogo('mn-mobile-logo'));
  var mobRight = document.createElement('div');
  mobRight.className = 'mn-right';
  mobRight.appendChild(createCart());
  mobRight.appendChild(mobClose);
  mobTop.appendChild(mobRight);

  var mobUl = document.createElement('ul');
  mobUl.className = 'mn-mobile-links';
  [{href:'/pages/bundle-builder', label:'Bundle Builder'},
   {href:'/collections/sauerkraut', label:'Sauerkraut'},
   {href:'/collections/kimchi', label:'Kimchi'},
   {href:'/collections/sauces', label:'Sauces'}
  ].forEach(function(l){
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = l.href;
    var label = document.createElement('span');
    label.className = 'mn-mob-label';
    label.textContent = l.label;
    a.appendChild(label);
    li.appendChild(a);
    mobUl.appendChild(li);
  });

  var mobCtaWrap = document.createElement('div');
  mobCtaWrap.className = 'mn-mobile-cta-wrap';
  var mobCta = document.createElement('a');
  mobCta.href = '/pages/bundle-builder';
  mobCta.className = 'mn-mobile-cta';
  mobCta.textContent = 'Build Your Own Pack \u2192';
  mobCtaWrap.appendChild(mobCta);

  var mobBrand = document.createElement('div');
  mobBrand.className = 'mn-mobile-brand';
  [{href:'/pages/about',label:'About Us'},{href:'/blogs/education',label:'Education'},{href:'/pages/contact',label:'Contact Us'},{href:'/pages/locations',label:'Locations'}].forEach(function(l){
    var a = document.createElement('a');
    a.href = l.href;
    a.textContent = l.label;
    mobBrand.appendChild(a);
  });

  /* Mobile quote — built with safe DOM methods */
  var mobQuote = document.createElement('div');
  mobQuote.className = 'mn-mobile-quote';
  var qStars = document.createElement('span');
  qStars.className = 'mn-q-stars';
  qStars.textContent = '\u2605\u2605\u2605\u2605\u2605';
  var qText = document.createElement('p');
  qText.className = 'mn-q-text';
  qText.textContent = '\u201CI\u2019ve struggled with IBS for years. After 6 weeks of daily kraut, my symptoms improved dramatically. This is medicine in a glass jar.\u201D';
  var qAttr = document.createElement('p');
  qAttr.className = 'mn-q-attr';
  qAttr.textContent = '\u2714 Verified Buyer';
  mobQuote.appendChild(qStars);
  mobQuote.appendChild(qText);
  mobQuote.appendChild(qAttr);

  mob.appendChild(mobTop);
  mob.appendChild(mobUl);
  mob.appendChild(mobCtaWrap);
  mob.appendChild(mobBrand);
  mob.appendChild(mobQuote);

  document.body.insertBefore(mob, document.body.firstChild);
  document.body.insertBefore(nav, document.body.firstChild);

  /* Announcement bar */
  var announceDismissed = false;
  try { announceDismissed = sessionStorage.getItem('lc_announce_closed') === '1'; } catch(e){}
  if (!announceDismissed) {
    var announce = document.createElement('div');
    announce.className = 'mn-announce';
    announce.id = 'mnAnnounce';
    var bolt = document.createElementNS('http://www.w3.org/2000/svg','svg');
    bolt.setAttribute('viewBox','0 0 24 24');bolt.setAttribute('fill','none');
    bolt.setAttribute('stroke','currentColor');bolt.setAttribute('stroke-width','2');
    var boltPath = document.createElementNS('http://www.w3.org/2000/svg','path');
    boltPath.setAttribute('d','M13 2L3 14h9l-1 8 10-12h-9l1-8z');
    bolt.appendChild(boltPath);
    announce.appendChild(bolt);
    var aText = document.createElement('span');
    aText.textContent = 'Free 2-Day Shipping \u2014 Packed Cold';
    announce.appendChild(aText);
    var aClose = document.createElement('button');
    aClose.className = 'mn-announce-close';
    aClose.setAttribute('aria-label','Dismiss');
    var xSvg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    xSvg.setAttribute('viewBox','0 0 24 24');xSvg.setAttribute('fill','none');
    xSvg.setAttribute('stroke','currentColor');xSvg.setAttribute('stroke-width','2.5');
    var x1 = document.createElementNS('http://www.w3.org/2000/svg','line');
    x1.setAttribute('x1','18');x1.setAttribute('y1','6');x1.setAttribute('x2','6');x1.setAttribute('y2','18');
    var x2 = document.createElementNS('http://www.w3.org/2000/svg','line');
    x2.setAttribute('x1','6');x2.setAttribute('y1','6');x2.setAttribute('x2','18');x2.setAttribute('y2','18');
    xSvg.appendChild(x1);xSvg.appendChild(x2);
    aClose.appendChild(xSvg);
    announce.appendChild(aClose);
    document.body.insertBefore(announce, document.body.firstChild);
    document.body.classList.add('has-announce');
    var syncAnnounceH = function(){
      document.documentElement.style.setProperty('--mn-announce-h', Math.round(announce.getBoundingClientRect().height) + 'px');
    };
    syncAnnounceH();
    window.addEventListener('resize', syncAnnounceH);
    window.addEventListener('orientationchange', function(){ setTimeout(syncAnnounceH, 200); });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(syncAnnounceH); }
    aClose.addEventListener('click', function(){
      announce.remove();
      document.body.classList.remove('has-announce');
      document.documentElement.style.setProperty('--mn-announce-h', '0px');
      try { sessionStorage.setItem('lc_announce_closed','1'); } catch(e){}
    });
  } else {
  }

  /* Events */
  function toggleMobile(){
    var isOpen = mob.classList.toggle('open');
    burger.classList.toggle('open');
    document.body.style.overflow = isOpen ? 'hidden' : '';
  }
  burger.addEventListener('click', toggleMobile);
  mobClose.addEventListener('click', toggleMobile);
  mob.querySelectorAll('a').forEach(function(a){
    a.addEventListener('click', function(){ if (mob.classList.contains('open')) toggleMobile() });
  });

  window.addEventListener('scroll', function(){
    nav.classList.toggle('scrolled', scrollY > 40);
  }, {passive:true});

  /* Fetch cart count on load */
  updateCartCount();
})();
